// extracted by mini-css-extract-plugin
export default {"root":"custom-scrollbars_root__jZjy-","thumb":"custom-scrollbars_thumb__y5m5H","view":"custom-scrollbars_view__j775w"};